import {
  buildingsFilter,
  buildingsFilterSelection,
  defaultFoodTypesData,
  defaultOrderByClassesGroupData,
  defaultOrgTypesDataReceiver,
  foodTypesFilter,
  foodTypesFilterSelection,
  orderByClassesGroupFilter,
  orderByClassesGroupFilterSelection,
  orgTypesFilter,
  orgTypesFilterSelection,
  orgsFilter,
  orgsFilterSelection,
  periodFilter,
} from 'app/dataProviders/filter-items'

export const filterInit = () => {
  orgTypesFilter.addDataReceiver(defaultOrgTypesDataReceiver)
  orgTypesFilter.dataReceive()
  orgTypesFilter.setStatusReady()

  orderByClassesGroupFilter.updateData(defaultOrderByClassesGroupData)

  foodTypesFilter.updateData(defaultFoodTypesData)

  const unsubscribeBuildingsFromOrgs = orgsFilterSelection.subscribeDataBox(buildingsFilter)
  // отключены фильтры для для группировки по "категориям льгот и комплектам"
  // const unsubscribeSalePointsFromOrgs = orgsFilterSelection.subscribeDataBox(salePointsFilter)
  // const unsubscribeSalePointsFromBuildings =
  //   buildingsFilterSelection.subscribeDataBox(salePointsFilter)

  return () => {
    unsubscribeBuildingsFromOrgs()
    // unsubscribeSalePointsFromOrgs()
    // unsubscribeSalePointsFromBuildings()

    orgsFilterSelection.reset()
    orgTypesFilterSelection.reset()
    buildingsFilterSelection.reset()
    orderByClassesGroupFilterSelection.reset()
    foodTypesFilterSelection.reset()

    orgsFilter.reset()
    orgTypesFilter.reset()
    buildingsFilter.reset()
    periodFilter.reset()
    orderByClassesGroupFilter.reset()
    foodTypesFilter.reset()
  }
}

export const resetToDefaultAll = () => {
  orgsFilterSelection.resetToDefault()
  orgTypesFilterSelection.resetToDefault()
  buildingsFilterSelection.resetToDefault()
  orderByClassesGroupFilterSelection.resetToDefault()
  foodTypesFilterSelection.resetToDefault()
}
